import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBusinessesState } from ".";

export interface ISetBusinessNameResponse {
    businessType: number;
    name: string;
}

export const setBusinessName = createAsyncThunk<ISetBusinessNameResponse, { businessType: number, name: string }>(
    'setBusinessName',
    async ({ businessType, name }) => await api.businesses.setName(businessType, name)
);

const setBusinessNameHandler = (builder: ActionReducerMapBuilder<IBusinessesState>) => {
    builder
        .addCase(setBusinessName.pending, (state: IBusinessesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(setBusinessName.fulfilled, (state: IBusinessesState, action: PayloadAction<ISetBusinessNameResponse>) => {
            state.loading = false;

            if (!state.activeBusiness || !action.payload)
                return;

            state.activeBusiness.name = action.payload.name;

            const business = state.businesses.find(business => business.type === action.payload.businessType);
            if (business)
                business.name = action.payload.name;
        })
        .addCase(setBusinessName.rejected, (state: IBusinessesState) => {
            state.loading = false;
            state.error = 'Unable to set business name';
        });
};

export default setBusinessNameHandler;